import { Drawer, useBreakpoints } from '@orfium/ictinus';
import React, { useCallback, useEffect } from 'react';
import config from 'src/config';
import { Ability } from 'src/ducks/user';

import {
  PolicyParagraph,
  PolicyWrapper,
  PrivacyPolicyContainer,
  PrivacyPolicyLink,
  SidebarPolicyLinks,
  SidebarWrapper,
} from './Sidebar.style';

export type ReduxProps = {
  sidebarIsOpen: boolean;
  ability: Ability | undefined;
};

export type ReduxActions = {
  openSidebar(): void;
  closeSidebar(): void;
};

const Sidebar: React.FC<ReduxProps & ReduxActions> = ({
  sidebarIsOpen,
  ability,
  openSidebar,
  closeSidebar,
}) => {
  const breakpoints = useBreakpoints();

  useEffect(() => {
    if (!breakpoints.des1366) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }, [breakpoints.des1366, openSidebar, closeSidebar]);

  const setExpanded = useCallback(
    (isExpanded: boolean) => (isExpanded ? openSidebar() : closeSidebar()),
    [openSidebar, closeSidebar]
  );

  return (
    <SidebarWrapper>
      <Drawer
        expanded={sidebarIsOpen}
        setExpanded={setExpanded}
        menuItems={(ability && config.menuItems(ability)) || []}
      />
      <SidebarPolicyLinks isOpen={sidebarIsOpen}>
        <PrivacyPolicyContainer expanded={sidebarIsOpen}>
          <PrivacyPolicyLink
            href={
              'https://video-hunter-public.s3.us-east-1.amazonaws.com/Privacy+Policy+Video+Hunter.pdf'
            }
            target="_blank"
            rel="noreferrer noopener"
          >
            Privacy Policy
          </PrivacyPolicyLink>
          <div>|</div>
          <PrivacyPolicyLink
            href={
              'https://video-hunter-public.s3.us-east-1.amazonaws.com/Terms+of+Use+-+Video+Hunter.pdf'
            }
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms of Use
          </PrivacyPolicyLink>
        </PrivacyPolicyContainer>

        <PolicyWrapper>
          <PolicyParagraph>
            The API Client uses YouTube API Services, and is subject to the{' '}
            <a href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer noopener">
              YouTube API Terms of Service
            </a>{' '}
            and{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">
              Google Privacy Policy
            </a>
            .
          </PolicyParagraph>
        </PolicyWrapper>
      </SidebarPolicyLinks>
    </SidebarWrapper>
  );
};

export default Sidebar;
